import React, { useEffect, useState, useRef } from "react"
import { useLanguage } from "../../contexts/LanguageContext"
import locales from "../../locales.json"
import "../../ressource/css/components/LanguageBubble.css"
import LanguageFlag from "./LanguageFlag"

/**
 * Floating language selector with dropdown menu.
 * Displays current language flag and name, allows switching between available languages.
 * @returns {JSX.Element}
 */
const LanguageBubble = () => {
  const { currentLanguage, changeLanguage, availableLanguages } = useLanguage()
  const [open, setOpen] = useState(false)
  const ref = useRef()

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  /**
   * Gets localized language name based on current language context.
   * @param {string} languageCode
   * @returns {string} Localized language name
   */
  const getLocalizedLanguageName = languageCode => {
    if (locales.languageNames && locales.languageNames[currentLanguage]) {
      return locales.languageNames[currentLanguage][languageCode] || languageCode
    }
    const lang = availableLanguages.find(l => l.code === languageCode)
    return lang ? lang.label : languageCode
  }

  const currentLangName = getLocalizedLanguageName(currentLanguage)

  /**
   * Changes the current language and closes the dropdown.
   * @param {string} languageCode
   */
  const handleLanguageChange = languageCode => {
    changeLanguage(languageCode)
    setOpen(false)
  }

  return (
    <div className="language-bubble" ref={ref}>
      <LanguageFlag languageCode={currentLanguage} size={24} onClick={() => setOpen(!open)} style={{ cursor: "pointer" }} />
      <span className="lang-label" onClick={() => setOpen(!open)} style={{ cursor: "pointer" }}>
        {currentLangName}
      </span>
      {open && (
        <div className="language-dropdown">
          {availableLanguages.map(l => (
            <div key={l.code} className={`language-option${l.code === currentLanguage ? " selected" : ""}`} onClick={() => handleLanguageChange(l.code)}>
              <LanguageFlag languageCode={l.code} size={24} />
              <span className="lang-label">{getLocalizedLanguageName(l.code)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default LanguageBubble
